import { render, staticRenderFns } from "./TransferModuleModal.vue?vue&type=template&id=cad66f8c&scoped=true&"
import script from "./TransferModuleModal.vue?vue&type=script&lang=ts&"
export * from "./TransferModuleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad66f8c",
  null
  
)

export default component.exports